import Column from '@components/column'
import Banner from './banner'
import Availabilities from '@commons/availabilities'
import { useSelector } from 'react-redux'
import CardHeading from '@commons/headings/card'
const DoctorAvailabilitiesPage = () => {
  const { data: user } = useSelector((state: any) => state.user)

  return (
    <Column rowGap={20}>
      <Banner />
      <CardHeading title="Availability" />
      <Availabilities
        userId={user?.id}
        appointmentType={user?.infos?.appointmentType}
      />
    </Column>
  )
}

export default DoctorAvailabilitiesPage
